// Helper function to check if element is in viewport
function isInViewport(el) {
	const rect = el.getBoundingClientRect();
	return (
		rect.top < window.innerHeight &&
		rect.bottom > 0
	);
}

// Helper function for animation
function animateCounter(el, duration = 3000) {
	const target = parseInt(el.textContent);
	const start = 0;
	const startTime = performance.now();

	function update(currentTime) {
		const elapsed = currentTime - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const current = Math.ceil(start + (target - start) * progress);
		el.textContent = current;

		if (progress < 1) {
			requestAnimationFrame(update);
		}
	}

	requestAnimationFrame(update);
}

// Main functionality
function handleNumbersAnimation() {
	document.querySelectorAll('.numbers').forEach((numberEl) => {
		if (isInViewport(numberEl)) {
			numberEl.classList.add('is-animated');
		}

		if (numberEl.classList.contains('is-animated') && 
				numberEl.getAttribute('data-animated') === 'false') {
			numberEl.setAttribute('data-animated', 'true');
			numberEl.querySelectorAll('.num').forEach((num) => {
				animateCounter(num);
			});
		}
	});
}

window.addEventListener('load', handleNumbersAnimation);
window.addEventListener('resize', handleNumbersAnimation);
window.addEventListener('scroll', handleNumbersAnimation);
